// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"014ad0d1","204":"60a04cad","512":"db6fba18","988":"35a2aa58"}[chunkId] + ".chunk.js";
};